import { tapFlashError } from './flash';

function getSuccessMessage(exportParams, filterKey, entityName) {
  const filterValue = Array.isArray(exportParams?.[filterKey])
    ? exportParams[filterKey][0]
    : exportParams?.[filterKey];

  if (!filterValue) {
    return `Email with all ${entityName} is being prepared`;
  }

  const displayValue = filterValue.toLowerCase();

  return `Email with ${displayValue} ${entityName} is being prepared`;
}

export default function createExportDump(apiMethod, filterKey, entityName) {
  return function dump(exportParams) {
    return apiMethod({
      search: exportParams,
    })
      .then(response => {
        if (response) {
          response.successMessage = getSuccessMessage(
            exportParams,
            filterKey,
            entityName,
          );
        }
        return response;
      })
      .catch(tapFlashError());
  };
}
